import { OnboardingLayout } from '@forwardflow/layouts/OnboardingLayout'
import { OnboardingSteps } from '@forwardflow/modules/onboarding'

export default function OnboardingPage() {
   return (
      <OnboardingLayout>
         <OnboardingSteps />
      </OnboardingLayout>
   )
}
